export default __webpack_public_path__ + "static/media/profile-avatar.79509d43.svg";